module.exports = "<div class=chat-message> <div ng-bind-html=self.getHtml() style=white-space:pre-line></div> </div>";